import { useEffect } from 'react';
import { accountStore } from '@/services/auth/store';
import { preloadSiblingsForPath } from '@/services/router/sibling-preload';

/**
 * Warm the Hydra-owned pages reachable from wherever the user currently is.
 *
 * Embedded-app navigations reach the router's location store too, so this fires
 * on a tab change inside the embedded app, not only on a Hydra route change.
 *
 * The account is a second trigger rather than a dependency: rollout-flagged
 * routes read as embedded-owned until the account resolves, so a cold load that
 * lands directly on an embedded tab has to be reconsidered once the flags exist.
 */
export function useSiblingPreload(pathname: string) {
  useEffect(() => {
    preloadSiblingsForPath(pathname);
    return accountStore.listen(() => {
      preloadSiblingsForPath(pathname);
    });
  }, [pathname]);
}
